import { useId } from "react";

export const LogoMark = ({ size = 40, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
        aria-hidden="true"
        data-testid="logo-mark"
    >
        <rect width="64" height="64" rx="14" fill="#380B12" />
        <rect x="5.5" y="5.5" width="53" height="53" rx="10" fill="none" stroke="#D4AF37" strokeWidth="1.6" />
        <text
            x="32"
            y="41"
            textAnchor="middle"
            fontFamily="'Fraunces', Georgia, serif"
            fontWeight="700"
            fontSize="25"
            letterSpacing="1"
            fill="#D4AF37"
        >
            BG
        </text>
        <rect x="27" y="48" width="10" height="2.6" rx="1.3" fill="#D4AF37" />
    </svg>
);

export const RotatingBadge = ({ text, icon = null, className = "" }) => {
    const id = useId();
    return (
        <div className={"relative " + className}>
            <svg viewBox="0 0 120 120" className="h-full w-full animate-spin-slow" aria-hidden="true">
                <defs>
                    <path id={id} d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" fill="none" />
                </defs>
                <text
                    fill="currentColor"
                    style={{ fontSize: 11, letterSpacing: 2.2, fontFamily: "Outfit, sans-serif", fontWeight: 600 }}
                >
                    <textPath href={`#${id}`} textLength="288" lengthAdjust="spacingAndGlyphs">
                        {text}
                    </textPath>
                </text>
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">{icon}</div>
        </div>
    );
};